import { OverviewDetailedViewModel } from "@common/components/overviewStepSection/OverviewStepSection.types.ts";
import { AllSystemInfoProps } from "./AllSystemInfo.tsx";

import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useAllSystemInfo(props: AllSystemInfoProps) {
    const { systemId } = props;

    const url = `/SystemOverview/${systemId}/extended-system-details`;
    const { isLoading, data } = useDotLegalQuery<OverviewDetailedViewModel>(url);

    return {
        isLoading,
        data,
    };
}
